/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { useContext } from 'react';
export var envNames = {
    LOCAL: 'local',
    STAGE: 'stage',
    PRODUCTION: 'production',
};
var envFromEnvVars = function () { return process.env.APP_ENV || process.env.REACT_APP_ENV; };
export function getValidEnvironment(env) {
    if (env === void 0) { env = envFromEnvVars(); }
    var validEnvironment;
    if (env && typeof env === 'string') {
        validEnvironment = envNames[env.toUpperCase()];
    }
    return validEnvironment || envNames.PRODUCTION;
}
export var EnvContext = React.createContext(getValidEnvironment(envFromEnvVars()));
/**
 * React hook to get current environment info from context unless given env param is a valid one.
 */
export var useEnv = function () {
    var envInContext = useContext(EnvContext);
    return envInContext;
};
export var EnvProvider = function (_a) {
    var value = _a.value, children = _a.children;
    return React.createElement(EnvContext.Provider, { value: value || getValidEnvironment(envFromEnvVars()) }, children);
};
